import React, { useEffect } from 'react';

// Import your newly created components
import AboutHeader from '../../component/About/AboutHeader';
import FounderProfile from '../../component/About/FounderProfile';
import ExperienceStats from '../../component/About/ExperienceStats';
import CoreCompetencies from '../../component/About/CoreCompetencies';
import Credentials from '../About/AboutCTA';

export default function About() {
      
  useEffect(() => {
    document.title = "CMJ Global | About Us";
  }, []);

  return (
    <div className="bg-[#F9F8F3] min-h-screen pt-24 pb-20 font-sans selection:bg-[#87412A]/10">
      
      {/* 1. Header Section */}
      <AboutHeader />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          {/* 2. Left Column */}
          <FounderProfile />

          {/* 3. Right Column (Sidebar) */}
          <div className="lg:col-span-5 space-y-8">
            <ExperienceStats />
            <CoreCompetencies />
            <Credentials />
          </div>

        </div>
      </div>
    </div>
  );
}